<template>
    <div class="limits">
        <form @submit.prevent="save" class="main-form" v-if="isSupervisor">
            <custom-input 
                v-model="limit"
                :title="$t('WEBSHOPS__LIMIT')"
                :helperText="helperText"
                inputType="number"
                :isRequired=true
            />
            <button class="btn">{{ buttonText }}</button>
        </form>
        <h3 v-else v-html="webshopLimitText"></h3>
        <custom-snackbar 
            v-if="snackbar.visible"
            :text="snackbar.text"
            :purpose="snackbar.purpose"
            @close="snackbar.visible = false"
        />
    </div>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
import axios from '@/Helpers/AxiosInstance.js'
export default {
    components: {
        CustomInput, CustomSnackbar,
    },
    props: {
        webshopID: Number,
    },
    created() {
        this.getLimit()
    },
    data() {
        return {
            limitsItem: null,
            limit: '',
            snackbar: {
                text: '',
                purpose: 'error',
                visible: false,
            }
        }
    },
    methods: {
        getLimit() {
            axios
                .get('WebShop/GetWebShopLimits', { params: {
                    WebShopId: this.webshopID
                }})
                .then(resp => {
                    if(resp.data.response.length > 0) {
                        this.limit = resp.data.response[0].maxBetAmountDecimal
                        this.limitsItem = resp.data.response[0]
                    }
                })
        },
        save() {
            if(!this.limit || this.limit <= 0) return
            if(this.limitsItem) {
                let data = {
                    id: this.limitsItem.id,
                    maxBetAmount: this.limit,
                }
                axios
                    .post('WebShop/EditWebShopLimit', data)
                    .then(resp => {
                        if(resp.data.status == 1) {
                            this.getLimit()
                            this.snackbar.text = 'Successfully Edited Limit!'
                            this.snackbar.purpose = 'success'
                            this.snackbar.visible = true
                        }
                        else {
                            this.showError(resp.data.status)
                        }
                    })
                    .catch(() => {
                        this.showError()
                    })
            }
            else {
                let data = {
                    webShopId: this.webshopID,
                    maxBetAmount: this.limit,
                    currency: this.currencyID,
                }
                axios
                    .post('WebShop/CreateWebShopLimit', data)
                    .then(resp => {
                        if(resp.data.status == 1) {
                            this.getLimit()
                            this.snackbar.text = 'Successfully Created Limit!'
                            this.snackbar.purpose = 'success'
                            this.snackbar.visible = true
                        }
                        else {
                            this.showError(resp.data.status)
                        }
                    })
                    .catch(() => {
                        this.showError()
                    })
            }
        },
        showError(status) {
            this.snackbar.purpose = 'error'
            this.snackbar.text = 'An Error Occurred While Activating!'
            this.snackbar.visible = true
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) this.snackbar.text = this.$t('STATUS-CODE__' + code.value)
        }
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        },
        helperText() {
            return `*${this.$t('WEBSHOPS__LIMIT_IN')} ${this.currencyCode}`
        },
        buttonText() {
            if(this.limit) {
                return this.$t('WEBSHOPS__UPDATE')
            }
            return this.$t('WEBSHOPS__SAVE')
        },
        statusCodes() {
            return this.$store.state.statusCodes
        },
        currencyCode() {
            return this.$store.state.webshops.filter(el => el.id == this.webshopID)[0].currencyName
        },
        currencyID() {
            return this.$store.state.webshops.filter(el => el.id == this.webshopID)[0].currency
        },
        webshopLimitText() {
            if(this.limitsItem) {
                return `${this.$t('WEBSHOPS__LIMIT')}: ${this.limit} <span>${this.currencyCode}</span>`
            }
            else {
                return 'No Limits'
            }
        }
    },
}
</script>

<style lang="scss" scoped>
    .limits {
        margin-top: 60 * $rem;

        form {
            display: flex;
        }

        h3 {
            text-align: center;
            font-weight: 400;
            font-size: 20px;
            color: rgb(88, 88, 88);

            /deep/ span {
                font-weight: 500;
            }
        }
    }
</style>